<script setup>
import { computed } from 'vue';
import SamlSettings from './components/SamlSettings.vue';
import SamlPaywall from './components/SamlPaywall.vue';

import { usePolicy } from 'dashboard/composables/usePolicy';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const { shouldShow, shouldShowPaywall } = usePolicy();

const shouldShowSaml = computed(() =>
  shouldShow(
    FEATURE_FLAGS.SAML,
    ['administrator'],
    [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE]
  )
);
const showPaywall = computed(() => false); // 不显示付费墙
</script>

<template>
  <div class="ws-page flex flex-col w-full h-full overflow-hidden">
    <!-- Header -->
    <header
      class="ws-header flex items-center justify-between px-6 flex-shrink-0"
      style="height: 50px"
    >
      <div class="flex items-center gap-2">
        <span class="i-ph-shield-check-bold size-5 ws-icon" />
        <h1 class="ws-title">{{ $t('SECURITY_SETTINGS.TITLE') }}</h1>
      </div>
    </header>

    <!-- Description -->
    <div class="ws-desc-bar px-6 py-3">
      <p class="text-sm ws-desc">{{ $t('SECURITY_SETTINGS.DESCRIPTION') }}</p>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto p-6">
      <SamlPaywall v-if="showPaywall" />
      <SamlSettings v-else-if="shouldShowSaml" />
      <div v-else class="flex flex-col items-center justify-center py-24">
        <div class="ws-empty-icon">
          <span class="i-ph-shield-check-bold size-10 ws-icon" />
        </div>
        <h3 class="ws-empty-title">No security settings available</h3>
        <p class="ws-empty-desc">
          Security settings will appear here once enabled.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ── White-theme variables for this page ── */
.ws-page,
.dark .ws-page {
  background: #ffffff !important;
}

.ws-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.ws-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}
.ws-icon {
  color: #6b7280;
}

.ws-desc-bar {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.ws-desc {
  color: #4b5563;
  margin: 0;
}

/* Empty state */
.ws-empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.ws-empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}
.ws-empty-desc {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* Sub-components */
:deep(.text-n-slate-12) {
  color: #111827 !important;
}
:deep(.text-n-slate-11) {
  color: #4b5563 !important;
}
:deep(.text-n-slate-10) {
  color: #6b7280 !important;
}
:deep(.bg-n-background),
:deep(.bg-n-solid-1),
:deep(.bg-n-solid-2) {
  background: #ffffff !important;
}
:deep(.border-n-weak) {
  border-color: #e5e7eb !important;
}
:deep(label) {
  color: #374151 !important;
}
:deep(input:not(.reset-base)),
:deep(select:not(.reset-base)) {
  background: #ffffff !important;
  border-color: #d1d5db !important;
  color: #111827 !important;
}
</style>
